import { createFileRoute, redirect } from "@tanstack/react-router";

/** Flyttad till ordlistan – permanent omdirigering. */
export const Route = createFileRoute("/zmarta")({
  beforeLoad: () => {
    throw redirect({ to: "/ordlista/$term", params: { term: "zmarta" }, statusCode: 301 });
  },
});
